import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styles from './Checkbox.module.css'

export function Checkbox({
  checked = false,
  indeterminate = false,
  onChange,
  disabled = false,
  id,
  name,
  required = false,
  label,
  className = '',
}) {
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  const classes = [
    styles.checkbox,
    indeterminate ? styles['checkbox--indeterminate'] : '',
    className,
  ].filter(Boolean).join(' ')

  const iconName = indeterminate
    ? 'indeterminate_check_box'
    : checked
      ? 'check_box'
      : 'check_box_outline_blank'

  return (
    <label className={classes}>
      <input
        ref={inputRef}
        className={styles.checkbox__input}
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
      />
      <span className={`${styles.checkbox__icon} material-icons-outlined`}>{iconName}</span>
      {label && <span className={styles.checkbox__label}>{label}</span>}
    </label>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.node,
  className: PropTypes.string,
}
